import { object } from "superstruct";

import GiftRegistryWithRegistrantSchema from "./GiftRegistryWithRegistrantSchema";

const UpdateGiftRegistryResponseSchema = object({
    giftRegistryWithRegistrant: GiftRegistryWithRegistrantSchema,
});

export default UpdateGiftRegistryResponseSchema;
